module.exports = __webpack_public_path__ + "static/img/Home69@2x.9bf6566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home69@2x.png
// module id = x2PU
// module chunks = 1